














































































































































































































































































































































































































































































































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { Company, domain, DBBranchData, User, DBAttachedFile, PaymentEdit, PaymentData, VueForm } from "@/domain";
import * as util from "@/util";
import * as uiUtil from "@/uiUtil";
import * as validationCard from "@/util/validationCard";
import * as lodash from "lodash";
import { getAllTimeZones } from "@/util/dates_m";
import QuickSnack from "@/components/QuickSnack.vue";
import Upload from "@/components/Upload.vue";
import DatePicker from "@/components/DatePicker.vue";
import MoneyField from "@/components/MoneyField.vue";
import NumberField from "@/components/NumberField.vue";

@Component({
  components: { QuickSnack, DatePicker, Upload, MoneyField, NumberField }
})
export default class PaymentForm extends Vue {
  @Prop({ required: true }) value!: PaymentData;
  @Prop({ default: "" }) id!: string;

  expirationType: "date" | "hours" = "date";
  payment = domain.backend.newPaymentData();

  saving = false;

  branches: DBBranchData[] = [];
  branchesLoading = false;

  // Form data
  paymentID = "";
  editAgain = false;
  selBranch: DBBranchData | null = null;

  created() {
    util.promiseEnd(this.loadBranches());
    this.replacePayment();
    this.onOriginalID();
    window.addEventListener("beforeunload", this.handleBeforeUnload);
  }

  beforeDestroy() {
    window.removeEventListener("beforeunload", this.handleBeforeUnload);
  }

  handleBeforeUnload(event: BeforeUnloadEvent) {
    if (this.saving) {
      event.preventDefault();
      event.returnValue = "";
    }
  }

  @Watch("id")
  onOriginalID() {
    this.paymentID = this.id;
  }

  @Watch("currentCompany")
  onCompanyChanged(newCompany?: Company, oldCompany?: Company) {
    if (!newCompany || (oldCompany && newCompany.id === oldCompany.id)) {
      return;
    }
    util.promiseEnd(this.loadBranches());
  }

  @Watch("value")
  onPaymentChanged() {
    this.replacePayment();
  }

  @Watch("payment", { deep: true })
  onOpType(payment: PaymentData) {
    if (payment.opType == "token") {
      this.payment.amountCents = 0;
      this.payment.createPaymentToken = false;
    }
  }

  @Watch("selBranch")
  changeBranch(selBranch: DBBranchData, prevBranch: DBBranchData) {
    if (this.paymentID.length !== 0 && !prevBranch) return;

    const urlOk = this.payment.notifyResultURL || "";
    const newBranchOk = selBranch?.notifyResultURL || "";
    const oldBranchOk = prevBranch?.notifyResultURL || "";
    if (urlOk === oldBranchOk) this.payment.notifyResultURL = newBranchOk;

    const urlKo = this.payment.notifyResultURLKo || "";
    const newBranchKo = selBranch?.notifyResultURLKo || "";
    const oldBranchKo = prevBranch?.notifyResultURLKo || "";
    if (urlKo === oldBranchKo) this.payment.notifyResultURLKo = newBranchKo;

    this.payment.notifyEmailKo = selBranch.notifyEmailKo || false;
  }

  get lang() {
    return this.$store.state.lang.data;
  }

  get paymentLangOptions() {
    /// IMPORTANTE: Estos idiomas son los disponibles en PAYMENT LINK
    ///  Actualizar esta lista si se agregan nuevos idiomas al sitio de payment link
    return [
      { key: "ES", name: "Español" },
      { key: "DE", name: "Alemán/Deutch" },
      { key: "EN", name: "English" },
      { key: "FR", name: "Français" },
      { key: "IT", name: "Italiano" },
      { key: "PT", name: "Portugés" },
      { key: "RU", name: "Russian" }
    ];
  }

  get paymentLangDef() {
    const curL = this.paymentLangOptions.find((l) => l.key === this.toUpper(this.payment.language));
    if (!curL) {
      return { key: "E0", name: "Idioma" };
    }
    return curL;
  }

  get opTypeOptions() {
    /// IMPORTANTE: Estas operaciones son solo las habilitadas para payment link
    return [
      { value: "sale", text: this.lang.sale },
      { value: "auth", text: this.lang.preauthorization },
      { value: "token", text: this.lang.tokenization }
    ];
  }

  get customFieldOptions() {
    return [
      { text: this.lang.payCFString, value: "string" },
      { text: this.lang.payCFNumber, value: "number" },
      { text: this.lang.payCFCountry2, value: "country_iso2" },
      { text: this.lang.payCFCountry3, value: "country_iso3" },
      // TODO: Agregar los tipos de campo LISTA
      // { text: this.lang.payCFSelect, value: "select" },
      // { text: this.lang.payCFRadioVertical, value: "radio_vertical" },
      // { text: this.lang.payCFRadioHorizontal, value: "radio_horizontal" },
      { text: this.lang.payCFCheckbox, value: "checkbox" },
      { text: this.lang.payCFDate, value: "date" },
      { text: this.lang.payCFPhone, value: "phone" }
    ];
  }

  get isLoading(): boolean {
    return this.$store.state.selectedCompanyLoading || this.branchesLoading || this.saving;
  }

  get currentCompany(): Company | null {
    return this.$store.state.selectedCompany;
  }

  get currentUser(): User | null {
    return this.$store.state.currentUser;
  }

  get timeZones() {
    return getAllTimeZones();
  }

  get snack(): QuickSnack {
    return this.$refs.snack as QuickSnack;
  }

  replacePayment() {
    this.payment = lodash.cloneDeep(this.value);
    this.expirationType = !this.payment.expirationHours ? "date" : "hours";
  }

  toUpper(s?: string) {
    if (!s) {
      return "";
    }
    return s.toUpperCase();
  }

  async loadBranches() {
    this.branchesLoading = true;
    if (this.currentCompany) {
      const branches = await domain.backend.paymentGetBranches(this.currentCompany.id);
      this.branches = (branches || []).filter((b) => b.paymentLink);
    } else {
      this.branches = [];
    }
    if (this.selBranch) {
      // If selectd but it doesn't exist in current branches unselect it
      if (this.branches.every((b) => b.branchID !== this.selBranch?.branchID)) {
        this.selBranch = null;
      }
    }
    if (this.payment.branchID && !this.selBranch) {
      // Try to select payment branch
      const foundBranch = this.branches.find((b) => b.branchID === this.payment.branchID);
      if (foundBranch) {
        this.selBranch = foundBranch;
      } else {
        util.logError("BRANCH NOT FOUND!", {
          id: this.payment.branchID,
          branches: this.branches
        });
        this.selBranch = null;
      }
    }
    this.branchesLoading = false;
  }

  validateForm() {
    if (!(this.$refs.paymentForm as VueForm).validate()) {
      this.snack.show(this.lang.errorVerifyFields, "error");
      return false;
    }
    if (!this.detailsTotal.valid) {
      this.snack.show(this.lang.errorSumIncorrect, "error");
      return false;
    }
    const branch = this.selBranch;
    if (!branch) {
      return false;
    }
    return true;
  }

  async cmdSave() {
    if (this.saving) return;
    if (!this.validateForm()) {
      util.scrollToTop();
      return;
    }
    try {
      this.saving = true;
      if (!this.selBranch) return;
      this.payment.companyID = this.selBranch.companyID;
      this.payment.branchID = this.selBranch.branchID;
      if (!util.isEmpty(this.payment.userCard)) {
        this.payment.changeCard = true;
      }
      if (this.expirationType == "date") {
        this.payment.expirationHours = 0;
      } else {
        this.payment.expiration = "";
      }
      if (this.payment.opType === "token") {
        this.payment.createPaymentToken = null;
        this.payment.amountCents = 0;
      }
      const paymentEdit: PaymentEdit = {
        id: this.paymentID,
        data: this.payment
      };
      const result = await domain.backend.updatePayment(paymentEdit);
      this.paymentID = result.id;
      this.payment.attachedFiles = result.attachedFiles;
      this.editAgain = false;
      this.snack.show(this.lang.savedRequest, "success");

      // Trigger events
      const eventPayment = lodash.cloneDeep(this.payment);
      this.$emit("input", eventPayment);
      this.$emit("saved", {
        paymentID: this.paymentID,
        payment: eventPayment
      });
      setTimeout(() => {
        util.scrollToTop();
      }, 1000);
    } catch (err) {
      util.logError("Error saving", err);
      this.snack.show(uiUtil.toErrorMsg(err, this.lang.errorCouldNotSave), "error");
    }
    this.saving = false;
  }

  cmdChangeCard() {
    this.payment.userCard = "";
    this.payment.userExpiration = "";
    this.payment.changeCard = true;
  }

  addDetail() {
    this.payment.details.push({
      description: "",
      amountCents: 0
    });
  }

  removeDetail(idx: number) {
    this.payment.details.splice(idx, 1);
  }

  addCustomField() {
    this.payment.customFormFields.push({
      name: "field_" + util.pseudoUUID(),
      type: "string",
      required: false,
      maxLength: 250,
      label: "",
      defaultValue: ""
    });
  }

  removeCustomField(idx: number) {
    this.payment.customFormFields.splice(idx, 1);
  }

  get detailsTotal(): { amount: number; valid: boolean } {
    if (this.payment.details.length === 0) {
      return { amount: 0, valid: true };
    }
    const amount = this.payment.details.reduce((prev, newv) => prev + Number(newv.amountCents), 0);
    return {
      amount,
      valid: !isNaN(amount) && Number(this.payment.amountCents) === amount
    };
  }

  attIsImage(item: DBAttachedFile): boolean {
    return item.contentType.startsWith("image");
  }
  attFileName(item: DBAttachedFile): string {
    const idx = item.fileRef.lastIndexOf("/");
    if (idx < 0) {
      return item.fileRef;
    }
    return item.fileRef.substring(idx + 1);
  }

  async removeAttachment(index: number, item: DBAttachedFile) {
    this.payment.attachedFiles.splice(index, 1);
    // Remove remote only if it's temporary upload
    try {
      await domain.backend.removeStorageFileIfTemp(item.fileRef);
      util.log("Removed", item.fileRef);
    } catch (err) {
      util.logError("Error removing file", item.fileRef, err);
    }
  }

  uploadFailed(err: unknown) {
    util.logError("Upload Failed", err);
  }

  uploadSuccess(newFileRef: string, fileName: string, mimeType: string) {
    this.payment.attachedFiles.push({
      inline: false,
      description: fileName,
      contentType: mimeType,
      fileRef: newFileRef
    });
  }

  get selBranchRules() {
    return [util.rules.required(this.lang.ruleSelectCompany)];
  }

  get requiredRules() {
    return [util.rules.required(this.lang.ruleRequiredField)];
  }

  get expirationRules() {
    if (this.expirationType == "date") {
      return [
        util.rules.required(this.lang.ruleRequiredField),
        util.rules.date(this.lang.ruleDateHigher, util.today())
      ];
    } else {
      return [util.rules.required(this.lang.ruleRequiredField), util.rules.minmax(this.lang.ruleMinValue1, 1, null)];
    }
  }

  get amountRules() {
    return [
      (value: unknown) => this.payment.opType === "token" || util.rules.required(this.lang.ruleInsertVaule)(value),
      (value: unknown) => this.payment.opType === "token" || util.toNumberSafe(value) > 0 || this.lang.ruleMinValue0
    ];
  }

  get emailRules() {
    return [util.rules.required(this.lang.requiredEmailAlert), util.rules.email(this.lang.ruleInvalidEmail)];
  }

  get cardRules() {
    return [validationCard.ruleNumber(this.lang.ruleInvalidValue, true)];
  }

  get cardMask() {
    return validationCard.maskNumber(this.payment.userCard);
  }

  get cardExpirationRules() {
    return [validationCard.ruleExpiration(this.lang.ruleInvalidValue2, !this.payment.userCard)];
  }
}
